import * as validate from "@repo/helpers/src/validators";
import { PostalCode } from "@repo/models";
import { useCallback } from "react";

import { useLocationPortalApi } from "./locationPortalApi";

export function useStatesApi() {
	const { Get } = useLocationPortalApi("States");

	const getCityByZip = useCallback(
		async function (zipCode: string) {
			try {
				if (validate.zipCode(zipCode)) return null;
				return await Get<PostalCode>(`City/${zipCode}`);
			} catch (e) {
				return null;
			}
		},
		[Get],
	);
	return { getCityByZip };
}
